import { render, staticRenderFns } from "./batchCloseOrderDialog.vue?vue&type=template&id=7b4d1844&scoped=true"
import script from "./batchCloseOrderDialog.vue?vue&type=script&lang=js"
export * from "./batchCloseOrderDialog.vue?vue&type=script&lang=js"
import style0 from "./batchCloseOrderDialog.vue?vue&type=style&index=0&id=7b4d1844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4d1844",
  null
  
)

export default component.exports